import { render, staticRenderFns } from "./Surcharge.vue?vue&type=template&id=8a6f02d6"
import script from "./Surcharge.vue?vue&type=script&lang=js"
export * from "./Surcharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports